const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export function resolveEnvironmentBadge({ mode, projectId, hostname }) {
  const normalizedProjectId = String(projectId || '').toLowerCase();
  const isLocal = LOCAL_HOSTS.has(String(hostname || '').toLowerCase());
  const isDevelopmentProject = normalizedProjectId.includes('dev')
    || normalizedProjectId.includes('development');

  if (isDevelopmentProject) {
    return { label: 'DEVELOPMENT', className: 'badge-info' };
  }

  // A local server backed by the production Firebase project is production
  // data, regardless of Vite's DEV flag.
  if (normalizedProjectId && (isLocal || mode === 'prod-local')) {
    return { label: 'PRODUCTION', className: 'badge-error' };
  }

  // Never guess that an unconfigured local server is Development.
  if (!normalizedProjectId && isLocal) {
    return { label: 'LOCAL', className: 'badge-warning' };
  }

  // The hosted production app needs no environment badge.
  return null;
}
